<template>
  <div>
    <span v-if="index" class="index"> ({{ arabizeNumerals(index + 1) }}) </span>
    <span :class="{ 'correct': isGood }">
      <span v-for="(t, n) in tokensWithSpaces" :key="n"
      :class="{ coll: example.coll_idx.filter(idx => t.indexes.includes(idx-1)).length }">{{t.token}}</span>
    </span>
    <b-link @click.stop="$emit('showDetails')"> <octicon name="eye"/> </b-link>
    <b-link v-if="!isGood" @click.stop="rate(false)"> <octicon name="x"/> </b-link>
    <b-link v-if="!isGood" @click.stop="rate(true)"> <octicon name="check"/> </b-link>
  </div>
</template>

<script>
import { api } from '../mixins/api.js'
import Octicon from 'vue-octicon/components/Octicon.vue'
import 'vue-octicon/icons/x'
import 'vue-octicon/icons/check'
import 'vue-octicon/icons/eye'
export default {
  name: 'CollocationExample',
  components: { Octicon },
  mixins: [api],
  props: {
    example: Object,
    isGood: Boolean,
    index: Number,
    coll: Object,
    diacritics: { type: Boolean, default: false }
  },
  computed: {
    id () { return this.example.ref },
    words () { return this.example.words },
    tokens () {
      const mwtByStartIndex = {}
      const mwtIndexes = new Set()
      for (const mwt of this.example.mwts) {
        mwtByStartIndex[mwt.indexes[0]] = mwt
        mwt.indexes.forEach(index => mwtIndexes.add(index))
      }

      const tokens = []
      this.example.words.forEach((word, idx) => {
        if (mwtByStartIndex[idx]) {
          tokens.push(mwtByStartIndex[idx])
        } else if (!mwtIndexes.has(idx)) {
          tokens.push({ 'token': word, 'indexes': [idx] })
        }
      })
      if (!this.diacritics) {
        tokens.forEach(function (t) { t.token = t.token.replace(/[\u064b-\u065f\u0670]/g, '') })
      }
      return tokens
    },
    tokensWithSpaces () {
      let tokens = this.tokens
      let prefixes = '([{'.split('')
      let suffixes = ')]},،:;؟.?!'.split('')
      for (let i = 0; i < tokens.length - 1; i++) {
        if (!prefixes.includes(tokens[i].token) && !suffixes.includes(tokens[i + 1].token)) {
          tokens[i].token += ' '
        }
      }
      return tokens
    },
    sentence () {
      return this.tokens.map(t => t.token).join(' ')
    }
  },
  methods: {
    rate (isGood) {
      if (!this.$store.user || this.user.isAnonymous) {
        console.log('REFS')
        console.log(this.$refs)
      }
      this.$store.dispatch('rateExample', { example: this.example, coll: this.coll, isGood })
    }
  }
}
</script>

<style scoped>
  span.coll {
    font-weight: bold
  }
  span.index {
    color: darkgray;
    margin-left: 5px
  }
  .octicon {
    margin-right: 5px;
    color: grey
  }
  .octicon:hover {
    color: var(--fg-color)
  }
</style>
